var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed top-0 left-0 h-screen w-full flex justify-center items-center z-50 bg-black bg-opacity-10"},[_c('div',{staticClass:"w-11/12 max-w-xl py-7 px-5 rounded-xl bg-white border-2"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }